// Footer.jsx
import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';

export function Footer({contactInfo}) {
    const year = new Date().getFullYear()

    return (
        <footer>
            <div className="container foot-grid">
                <div>
                    <div className="logo" style={{ marginBottom: '.6rem' }}>
                        <svg viewBox="0 0 48 48" aria-hidden="true" fill="none">
                            <defs>
                                <linearGradient id="g2" x1="0" y1="0" x2="1" y2="1">
                                    <stop offset="0" stopColor="var(--brand-2)" />
                                    <stop offset="1" stopColor="var(--brand)" />
                                </linearGradient>
                            </defs>
                            <path d="M24 41s-9.5-6.9-15.3-12.7C4.6 24.2 5 16.6 10 13.2a8.5 8.5 0 0 1 10 .6l4 3.2 4-3.2a8.5 8.5 0 0 1 10-.6c5.1 3.4 5.4 11-.7 15.1C33.5 34.1 24 41 24 41Z" stroke="url(#g2)" strokeWidth="2.5" fill="none" />
                            <path d="M22.5 23h-4v-4h-3v4h-4v3h4v4h3v-4h4z" fill="url(#g2)" />
                        </svg>
                        <strong>PATIENT CHOICE</strong>
                    </div>
                    <div className="subtle">
                        Healthcare & wellness supplies for Dominica. Genuine products, friendly guidance, and fast local delivery.
                    </div>
                </div>

                <div>
                    <strong>Shop</strong>
                    <div className="list" style={{ marginTop: '.6rem' }}>
                        <Link to="/category/otc">OTC Medicines</Link>
                        <Link to="/category/orthopedic">Orthopedic Supports</Link>
                        <Link to="/category/wound">Wound Care</Link>
                        <Link to="/category/mobility">Mobility Aids</Link>
                        <Link to="/category/diagnostics">Diagnostics</Link>
                        <Link to="/category/others">Others</Link>
                    </div>
                </div>

                <div>
                    <strong>Contact</strong>
                    <div className="list" style={{ marginTop: '.6rem' }}>
                        <span>Email: {contactInfo.email}</span>
                        <span>WhatsApp: {contactInfo.phone}</span>
                        <span>Address: {contactInfo.address}</span>
                    </div>
                </div>
            </div>

            <div
                className="container"
                style={{
                    marginTop: '1.2rem',
                    color: 'var(--muted)',
                    fontSize: '.9rem'
                }}
            >
                © <span id="year">{year}</span> Patient Choice. All rights reserved.
            </div>
        </footer>
    );
}

export default Footer;
